import { I as Icon, _ as _extends } from './Icon-BnBRpux5.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const Home = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      d: "M3.7966 18.9281v-8.8925c0-.3605.0799-.7013.2395-1.0225.1595-.3212.3822-.5873.668-.7985l5.9283-4.4463c.4018-.3065.8576-.4597 1.3675-.4597.5098 0 .9656.1532 1.3675.4597l5.9282 4.4463c.2859.2112.5085.4773.668.7985a2.266 2.266 0 01.2395 1.0225v8.8925c0 .6297-.2217 1.1662-.6652 1.6097s-.9801.6653-1.6098.6653h-2.743c-.3191 0-.5885-.1098-.808-.3293-.2196-.2196-.3295-.489-.3295-.8082v-4.976c0-.3193-.1097-.5888-.3292-.8083-.2195-.2195-.4889-.3292-.8083-.3292h-1.8205c-.3193 0-.5887.1097-.8082.3292-.2195.2195-.3293.489-.3293.8083v4.976c0 .3192-.1098.5886-.3295.8082-.2195.2195-.4888.3293-.808.3293h-2.743c-.6296 0-1.1662-.2218-1.6097-.6653s-.6653-.98-.6653-1.6097z"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      d: "M6.0716 18.9281h2.7908v-4.9283c0-.3191.1097-.5885.3292-.8082.2197-.2195.4891-.3293.8083-.3293h4c.3191 0 .5886.1098.8082.3293.2195.2197.3293.4891.3293.8082v4.9283h2.7907v-8.8925l-5.9282-4.446-5.9283 4.446v8.8925zm-2.275 0v-8.8925c0-.3595.0799-.7.2395-1.0218.1595-.3216.3822-.588.668-.7992l5.9283-4.4463c.4018-.3065.8576-.4597 1.3675-.4597.5098 0 .9656.1532 1.3675.4597l5.9282 4.4463c.2859.2112.5085.4776.668.7992.1597.3217.2395.6623.2395 1.0218v8.8925c0 .6297-.2217 1.1662-.6652 1.6097s-.9801.6653-1.6098.6653h-3.8385c-.3193 0-.5887-.1098-.8082-.3293-.2195-.2196-.3293-.489-.3293-.8082v-5.018h-1.9045v5.018c0 .3192-.1097.5886-.3292.8082-.2195.2195-.4889.3293-.8083.3293H6.0716c-.6296 0-1.1662-.2218-1.6097-.6653s-.6653-.98-.6653-1.6097z"
    }),
    strokertl: /*#__PURE__*/React.createElement("path", {
      d: "M6.0716 18.9281h2.7908v-4.9283c0-.3191.1097-.5885.3292-.8082.2197-.2195.4891-.3293.8083-.3293h4c.3191 0 .5886.1098.8082.3293.2195.2197.3293.4891.3293.8082v4.9283h2.7907v-8.8925l-5.9282-4.446-5.9283 4.446v8.8925zm-2.275 0v-8.8925c0-.3595.0799-.7.2395-1.0218.1595-.3216.3822-.588.668-.7992l5.9283-4.4463c.4018-.3065.8576-.4597 1.3675-.4597.5098 0 .9656.1532 1.3675.4597l5.9282 4.4463c.2859.2112.5085.4776.668.7992.1597.3217.2395.6623.2395 1.0218v8.8925c0 .6297-.2217 1.1662-.6652 1.6097s-.9801.6653-1.6098.6653h-3.8385c-.3193 0-.5887-.1098-.8082-.3293-.2195-.2196-.3293-.489-.3293-.8082v-5.018h-1.9045v5.018c0 .3192-.1097.5886-.3292.8082-.2195.2195-.4889.3293-.8083.3293H6.0716c-.6296 0-1.1662-.2218-1.6097-.6653s-.6653-.98-.6653-1.6097z"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
Home.displayName = "HomeIcon";

export { Home, Home as default };
